import { stockStream } from './streams';

/**
 * What the animals' populations share (review M116: each had its own copy):
 * the year their rates are taken over, a yearly survival's deaths a day, and
 * the draws a population's day takes, on its stock's stream of the day or at
 * their expected values. The reef fish's draws are their own (`FishDraws`,
 * island by island).
 */

/** Days a yearly rate is taken over: a common year's, the balances' year (a definition; the coral takes a Julian year's). */
export const YEAR_DAYS = 365;

/** The share of a class dying a day at a survival a year. */
export const dailyDeath = (survivalPerYear: number): number => 1 - survivalPerYear ** (1 / YEAR_DAYS);

/** The draws a population's day takes: the game's from its stock's stream of the day, a balance's and a world's opening their expected values. */
export interface PopulationDraws {
  /** How many of n, each with chance p. */
  share(n: number, p: number): number;
  /** How many, of an expected number. */
  count(mean: number): number;
}
/** The expected values, for a balance and for opening a world (no draw). */
export const EXPECTED_DRAWS: PopulationDraws = { share: (n, p) => n * p, count: (mean) => mean };

/** A population's draws on its stock's stream of the day (`stockStream`, its place's one stock): binomial shares of each count, Poisson counts (`Rng.count`). */
export function stockDraws(world: { seed: number; day: number }, salt: number, place: string, streamOf: typeof stockStream = stockStream): PopulationDraws {
  const rng = streamOf(world, salt, place, 0);
  return { share: (n, p) => rng.binomial(n, p), count: (mean) => rng.count(mean) };
}
